
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/build-cover-letter",
      function () {
        return require("private-next-pages/candidate/build-cover-letter/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/build-cover-letter"])
      });
    }
  